var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column",class:'item_' + _vm.classSuffix},_vm._l((_vm.data),function(item){return _c('div',{key:item.key,staticClass:"rest",class:_vm.getNextCalssColor()},[_c('span',{staticClass:"name_rest"},[_vm._v(_vm._s(item.name))]),_c('span',{staticClass:"tooltip"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }